import { render } from "./EventEditor.vue?vue&type=template&id=12d1d018&scoped=true&ts=true"
import script from "./EventEditor.vue?vue&type=script&lang=ts"
export * from "./EventEditor.vue?vue&type=script&lang=ts"

import "./EventEditor.vue?vue&type=style&index=0&id=12d1d018&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d1d018"]])

export default __exports__